export const BASE_WEIGHT_G = 120;

export const MATERIALS = {
  pla: { label: "PLA", usdPerGram: 0.07 },
  petg: { label: "PETG", usdPerGram: 0.09 },
} as const;

export const NOZZLES = {
  "0.2": { label: "0.2 mm", factor: 1.4, hint: "Nice finish · more material · higher price" },
  "0.4": { label: "0.4 mm", factor: 1, hint: "Standard nozzle. Price follows the material used." },
  "0.6": { label: "0.6 mm", factor: 0.7, hint: "Rough surface · less material · lower price" },
} as const;

export type MaterialId = keyof typeof MATERIALS;
export type NozzleId = keyof typeof NOZZLES;

export function isMaterial(value: string): value is MaterialId {
  return value in MATERIALS;
}

export function isNozzle(value: string): value is NozzleId {
  return value in NOZZLES;
}

export function estimate(material: MaterialId, nozzle: NozzleId, baseGrams = BASE_WEIGHT_G) {
  const grams = Math.round(baseGrams * NOZZLES[nozzle].factor);
  const rate = MATERIALS[material].usdPerGram;
  const usd = grams * rate;
  return {
    grams,
    rate,
    usd,
    cents: Math.round(usd * 100),
  };
}
